import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';

export const styles = StyleSheet.create({
  footer: {
    marginVertical: indent,
  },
  footerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});
